import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { labRequestIncidents } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTINCIDENT,
  DELETE_LABREQUESTINCIDENT,
  GET_LABREQUESTINCIDENTS,
  UPDATE_LABREQUESTINCIDENT
} from "./actionTypes";
import {
  addLabRequestIncidentFail,
  addLabRequestIncidentSuccess,
  deleteLabRequestIncidentFail,
  deleteLabRequestIncidentSuccess,
  getLabRequestIncidentsFail,
  getLabRequestIncidentsSuccess,
  setState,
  updateLabRequestIncidentFail,
  updateLabRequestIncidentSuccess,
} from "./actions";

function* fetchLabRequestIncidents({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labRequestIncidents, params.toString());
    yield put(setState(false));
    yield put(getLabRequestIncidentsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabRequestIncidentsFail(error));
  }
}

function* updateLabRequestIncident({ payload: labRequestIncidentObj }) {
  try {
    const { id, ...rest } = labRequestIncidentObj;
    yield call(patchApiCall, `${labRequestIncidents}/${id}`, rest);
    const response = yield call(getTable, `${labRequestIncidents}/${id}`);
    yield put(updateLabRequestIncidentSuccess(response));
  } catch (error) {
    yield put(updateLabRequestIncidentFail(error));
  }
}

function* updateLabRequestIncidentStatus({ payload: labRequestIncidentObj }) {
  try {
    const { id, ...rest } = labRequestIncidentObj;
    yield call(patchApiCall, `${labRequestIncidents}/${id}`, rest);
    const response = yield call(getTable, `${labRequestIncidents}/${id}`);
    yield put(updateLabRequestIncidentSuccess(response));
  } catch (error) {
    yield put(updateLabRequestIncidentFail(error));
  }
}

function* deleteLabRequestIncident({ payload: labRequestIncidentObj }) {
  try {
    yield call(deleteApiCall, `${labRequestIncidents}/${labRequestIncidentObj.id}`);
    yield put(deleteLabRequestIncidentSuccess(labRequestIncidentObj.id));
  } catch (error) {
    yield put(deleteLabRequestIncidentFail(error));
  }
}

function* postingLabRequestIncident({ payload: labRequestIncident }) {
  try {
    const response = yield call(postApiCall, labRequestIncidents, labRequestIncident);
    const responseData = yield call(getTable, `${labRequestIncidents}/${response.id}`);
    yield put(addLabRequestIncidentSuccess(responseData));
  } catch (error) {
    yield put(addLabRequestIncidentFail(error));
  }
}

function* labRequestIncidentsSaga() {
  yield takeEvery(GET_LABREQUESTINCIDENTS, fetchLabRequestIncidents);
  yield takeEvery(ADD_NEW_LABREQUESTINCIDENT, postingLabRequestIncident);
  yield takeEvery(UPDATE_LABREQUESTINCIDENT, updateLabRequestIncident);
  yield takeEvery(UPDATE_LABREQUESTINCIDENT, updateLabRequestIncidentStatus);
  yield takeEvery(DELETE_LABREQUESTINCIDENT, deleteLabRequestIncident);
}

export default labRequestIncidentsSaga;
